import { connect } from 'react-redux'
import { selectAccountId } from 'selectors/app/selectAccountId'
import {
  makeSelectRoomById,
  makeSelectIsLoadingRoomById,
  makeSelectIsLoadedRoomById,
} from 'ducks/chat/selectors/rooms'
import { selectIsMatrixClientAndUiReady } from 'ducks/chat/selectors/client'
import { doReadRoom, doFetchRoomById } from 'ducks/chat/actions/rooms'
import MatrixChat from './MatrixChat'

const select = () => {
  const selectRoomById = makeSelectRoomById()
  const selectIsLoadingRoomById = makeSelectIsLoadingRoomById()
  const selectIsLoadedRoomById = makeSelectIsLoadedRoomById()

  return (state, props) => {
    return {
      room: selectRoomById(state, props),
      accountId: selectAccountId(state),
      isLoading: selectIsLoadingRoomById(state, props),
      isLoaded: selectIsLoadedRoomById(state, props),
      isMatrixReady: selectIsMatrixClientAndUiReady(state),
    }
  }
}

const perform = {
  markAsRead: doReadRoom,
  fetchRoomById: doFetchRoomById,
}

export default connect(select, perform)(MatrixChat)
